module["exports"] = [
  "com",
  "net",
  "info",
  "vn",
  "com.vn"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/vi/internet/domain_suffix.js
// module id = 1703
// module chunks = 0